export default __webpack_public_path__ + "static/media/repayment-channel-icon2.97f225c3.png";